import { iTrack } from '../types/ITrack';
import {
  CrateTrackLike,
  readArtistValue,
  readTrackArtist,
  readTrackIsrc,
  readTrackTitle,
} from './readTrackIdentity';

export type { CrateTrackLike };
export { readArtistValue, readTrackArtist, readTrackIsrc, readTrackTitle };

const asLoose = (track: CrateTrackLike): Record<string, unknown> =>
  track as Record<string, unknown>;

const readText = (value: unknown): string =>
  typeof value === 'string' ? value.trim() : '';

const readNumber = (value: unknown): number | undefined =>
  typeof value === 'number' && Number.isFinite(value) ? value : undefined;

/** Normalize crate track rows from API, agent tools, or recommendations. */
export const normalizeCrateTrack = (track: CrateTrackLike): iTrack => {
  const raw = asLoose(track);
  const base = track as iTrack;

  const id =
    readText(raw.ID) ||
    readText(raw.SpotifyID) ||
    readText(raw.id) ||
    readText(raw._id);

  const key = raw.Key_Camelot ?? raw.Key ?? raw.key;
  const keyValue =
    typeof key === 'string' || typeof key === 'number' ? key : undefined;

  return {
    ...base,
    ID: id,
    SpotifyID: readText(raw.SpotifyID) || id,
    Artist: readTrackArtist(track),
    Title: readTrackTitle(track),
    isrc: readTrackIsrc(track),
    AlbumCover:
      readText(raw.AlbumCover) ||
      readText(raw.albumCover) ||
      readText((raw.album as { picture?: string } | undefined)?.picture),
    PreviewURL:
      readText(raw.PreviewURL) ||
      readText(raw.previewUrl) ||
      readText(raw.preview_url),
    BPM: readNumber(raw.BPM) ?? readNumber(raw.bpm),
    Key_Camelot: typeof keyValue === 'string' ? keyValue : undefined,
    Key: keyValue,
    energy: readNumber(raw.energy),
    danceability: readNumber(raw.danceability),
    valence: readNumber(raw.valence),
    popularity: readNumber(raw.popularity),
  };
};
